import { cn } from '../../util/bem';

export const tableClassName = cn('table');
